module.exports = __webpack_public_path__ + "static/media/unchecked-box.4a50a264.svg";